
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitoashtavinayakcabservice() {



    const cardData =
    {
        keyword: ' Mumbai to Ashtavinayak Cab Service ',
        heading: 'Vedant Travels: Mumbai to Ashtavinayak Cab Service',
        headingDescription: 'Vedant Travels offers a reliable and comfortable cab service from Mumbai to Ashtavinayak, ensuring a smooth pilgrimage journey. Whether you are traveling with family or in a group, our well-maintained fleet of sedans, SUVs, and luxury cars caters to all travel needs. Our professional drivers ensure a safe and hassle-free trip, covering all eight revered Ashtavinayak temples. With 24/7 availability, affordable fares, and an easy online booking system, Vedant Travels makes your spiritual journey convenient and stress-free.',

        top: 'Top Places to Visit in Ashtavinayak Temples with Vedant Travels',

     "topPlaces": [
    {
        "title": "Moreshwar Temple, Morgaon",
        "description": "Moreshwar Temple in Morgaon is the most important Ashtavinayak temple dedicated to Lord Ganesha. Located near Pune, this famous Ganesha temple attracts thousands of devotees seeking blessings for success, wisdom, and prosperity. The temple's architecture and spiritual significance make it a must-visit pilgrimage site in Maharashtra."
    },
    {
        "title": "Siddhivinayak Temple, Siddhatek",
        "description": "Siddhivinayak Temple in Siddhatek is a sacred Ashtavinayak temple situated on the banks of the Bhima River. It is the only Ganesha temple where Lord Ganesha has a right-sided trunk, symbolizing immense power and energy. Devotees visit this spiritual destination for wish fulfillment and overcoming obstacles in life."
    },
    {
        "title": "Ballaleshwar Temple, Pali",
        "description": "Ballaleshwar Temple in Pali is a renowned Ashtavinayak Ganpati temple named after Ballal, a devoted follower of Lord Ganesha. This unique Hindu temple features traditional Maratha architecture and is a popular religious site near Mumbai and Pune. It is believed to bless devotees with strength, devotion, and prosperity."
    },
    {
        "title": "Varadvinayak Temple, Mahad",
        "description": "Varadvinayak Temple in Mahad is an important Ashtavinayak temple known for granting wishes and bringing good fortune. Located near Lonavala, this famous Ganesha temple allows direct darshan of the idol, making it a highly revered pilgrimage site in Maharashtra."
    },
    {
        "title": "Chintamani Temple, Theur",
        "description": "Chintamani Temple in Theur is a significant Ashtavinayak temple near Pune, associated with the legend of Sage Kapila. Dedicated to Lord Ganesha, this sacred Hindu temple is believed to bring wisdom, peace, and relief from worries. The temple's serene surroundings make it a popular spiritual destination."
    },
    {
        "title": "Girijatmaj Temple, Lenyadri",
        "description": "Girijatmaj Temple in Lenyadri is a unique Ashtavinayak temple carved into a mountain cave. Located in the scenic hills of Junnar, near Pune, this historic Ganesha temple offers a blend of spiritual significance and adventure. Pilgrims and trekking enthusiasts visit to seek blessings and experience breathtaking views."
    },
    {
        "title": "Vighnahar Temple, Ozar",
        "description": "Vighnahar Temple in Ozar is an ancient Ashtavinayak temple dedicated to Lord Ganesha, the remover of obstacles. This popular Ganesha temple is known for its beautiful architecture and peaceful surroundings, making it an ideal religious destination near Pune and Nashik."
    },
    {
        "title": "Mahaganapati Temple, Ranjangaon",
        "description": "Mahaganapati Temple in Ranjangaon is the last and most powerful Ashtavinayak temple. Dedicated to Lord Ganesha in his supreme form, this temple attracts devotees seeking strength, prosperity, and success. Located near Pune, it is a must-visit pilgrimage site for spiritual seekers and devotees of Lord Ganpati."
    }
],

"services": [
    {
        "name": "Mumbai to Ashtavinayak Cab Service",
        "description": "Planning a trip to the Ashtavinayak temples? Book your ride with Vedant Travels for a comfortable and reliable journey from Mumbai to Ashtavinayak. We offer top-quality vehicles, including the Ertiga, Innova, and more, ensuring a smooth and enjoyable ride to all the eight sacred temples."
    },
    {
        "name": "Mumbai to Ashtavinayak Taxi",
        "description": "Experience a seamless taxi ride from Mumbai to Ashtavinayak with Vedant Travels. Our fleet includes well-maintained vehicles like Ertiga, Innova, and other options that provide comfort and convenience throughout your journey. Whether you're traveling alone, with family, or in a group, we’ve got you covered."
    },
    {
        "name": "Mumbai to Ashtavinayak Darshan Cab",
        "description": "Take a spiritual journey with Vedant Travels and book your Ashtavinayak Darshan cab. We provide safe and comfortable vehicles with professional drivers who are familiar with the routes to ensure you can focus on your pilgrimage experience without any worries."
    },
    {
        "name": "Ashtavinayak Temple Tour",
        "description": "Vedant Travels offers customized Ashtavinayak temple tours, ensuring a smooth and peaceful journey to all the eight temples. Our experienced drivers will guide you throughout the tour, making it a memorable and spiritual experience for you."
    },
    {
        "name": "Mumbai to Ashtavinayak Car Hire",
        "description": "Rent a car for your Ashtavinayak trip with Vedant Travels! We offer a variety of vehicles for hire, such as the Ertiga and Innova, with experienced drivers who will ensure your comfort and timely arrival at each temple."
    },
    {
        "name": "Mumbai to Ashtavinayak Taxi Booking",
        "description": "Booking a taxi for your Ashtavinayak trip has never been easier. At Vedant Travels, we offer flexible booking options, allowing you to book your Mumbai to Ashtavinayak taxi online or over the phone. Secure your ride today for a stress-free journey!"
    },
    {
        "name": "Mumbai to Ashtavinayak Cab Fare",
        "description": "At Vedant Travels, we provide transparent and competitive pricing for your Mumbai to Ashtavinayak cab ride. Whether it's a one-way trip or a round trip, you can rely on us for fair pricing with no hidden charges. Contact us for a detailed quote based on your specific requirements."
    },
    {
        "name": "Ashtavinayak Tour",
        "description": "Take the pilgrimage of a lifetime with Vedant Travels on our customized Ashtavinayak tour. We offer comfortable and reliable vehicles, ensuring you have an enjoyable and hassle-free trip to all the Ashtavinayak temples."
    },
    {
        "name": "Mumbai to Ashtavinayak Innova",
        "description": "For a premium, comfortable, and spacious ride, choose the Innova for your Mumbai to Ashtavinayak journey. Whether it’s a family trip or a group of friends, the Innova provides ample space and luxury for a relaxed travel experience."
    },
    {
        "name": "Mumbai to Ashtavinayak One Way Cab",
        "description": "Looking for a one-way ride from Mumbai to Ashtavinayak? Vedant Travels offers one-way cabs for your convenience, ensuring you reach your destination comfortably and efficiently. Book your one-way ride today for an affordable and hassle-free journey."
    },
    {
        "name": "Mumbai to Ashtavinayak Round Trip",
        "description": "Planning a round trip from Mumbai to Ashtavinayak? Vedant Travels offers round trip packages with reliable cabs and experienced drivers, ensuring you can complete your pilgrimage comfortably and on time. Contact us for the best pricing and convenient round-trip options."
    },
    {
        "name": "Mumbai to Ashtavinayak Car Rental",
        "description": "Rent a car with Vedant Travels for your Mumbai to Ashtavinayak trip. Choose from a variety of vehicles to suit your group size and travel preferences. Whether it’s a one-way or round-trip, our car rental service ensures flexibility, comfort, and a smooth journey."
    }
],


"tableData": [
    ["Mumbai to Ashtavinayak Cab Service", "Mumbai to Ashtavinayak Taxi"],
    ["Mumbai to Ashtavinayak Darshan Cab", "Ashtavinayak Temple Tour"],
    ["Mumbai to Ashtavinayak Car Hire", "Mumbai to Ashtavinayak Taxi Booking"],
    ["Mumbai to Ashtavinayak Cab Fare", "Ashtavinayak Tour"],
    ["Mumbai to Ashtavinayak Innova", "Mumbai to Ashtavinayak One Way Cab"],
    ["Mumbai to Ashtavinayak Round Trip", "Mumbai to Ashtavinayak Car Rental"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand how important your time is. Our drivers are dedicated to ensuring timely pickups and drop-offs, making your journey to Ashtavinayak smooth and punctual."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Experience a comfortable journey with our spacious, well-maintained vehicles. Designed for your comfort, our cars offer ample legroom, air conditioning, and cozy seating, ensuring a relaxing trip to Ashtavinayak."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our skilled drivers are experienced in long-distance travel, especially to Ashtavinayak. With deep knowledge of the best routes, they ensure a safe and comfortable ride, making your journey stress-free."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive rates with no hidden charges. Our transparent pricing ensures you get great value for your money, with clear and upfront costs."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our priority. Our vehicles are regularly serviced and equipped with modern safety features like airbags, seat belts, and GPS tracking. We adhere to strict safety protocols for a secure ride."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you prefer an early morning trip or a late-night return, Vedant Travels is available around the clock. Our customer support team is always ready to assist you whenever you need it."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Ashtavinayak cab is easy and convenient. You can book online through our website or app, or contact our customer service team for assistance with your reservation."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer personalized travel packages to suit your specific needs. Whether you're visiting Ashtavinayak for religious purposes or simply exploring, we will customize your journey to match your schedule and preferences."
    }
  ]



    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Ashtavinayak cab with Vedant Travels?',
            answer: 'You can easily book your cab online via our website or mobile app. Alternatively, feel free to call our customer service team for assistance with booking.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are experienced professionals, trained specifically for long-distance trips like Mumbai to Ashtavinayak. They ensure a safe, timely, and smooth journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai to Ashtavinayak travel?',
            answer: 'We offer a variety of well-maintained vehicles, including sedans, SUVs, and luxury cars. All vehicles are spacious and equipped for a comfortable ride.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Ashtavinayak cab rental?',
            answer: 'We accept a range of payment methods, including cash, credit/debit cards, and online payment via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round trip from Mumbai to Ashtavinayak?',
            answer: 'Yes, we offer round-trip options. Just provide your return details while booking, and we will take care of the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting or detours will be communicated to you clearly before the trip. We are committed to complete transparency with no hidden fees.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing around Ashtavinayak?',
            answer: 'Yes, we offer sightseeing services as part of your trip to Ashtavinayak. Visit the famous temples and other nearby attractions with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Ashtavinayak cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have larger or specialized luggage needs, please inform us during the booking process, and we\'ll make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Ashtavinayak?',
            answer: 'Yes, we offer corporate travel services, providing tailored solutions for business trips, conferences, and other professional needs, making your Ashtavinayak journey seamless.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Ashtavinayak travel?',
            answer: 'Vedant Travels stands out for its reliability, comfort, and affordability. With professional drivers, clean and spacious vehicles, and transparent pricing, we ensure your trip is safe, smooth, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Aakash Deshmukh",
            title: "Ashtavinayak Traveler",
            quote: "I took a trip from Mumbai to Ashtavinayak with Vedant Travels. The journey was comfortable, the driver was professional, and the vehicle was spotless. Highly recommended for anyone visiting Ashtavinayak!",
            rating: 5,
        },
        {
            name: "Mrs. Anjali Sharma",
            title: "Family Traveler",
            quote: "Our family had an amazing trip from Mumbai to Ashtavinayak. The driver was friendly and punctual, and the vehicle was perfect for the long journey. We'll definitely choose Vedant Travels again!",
            rating: 5,
        },
    ];
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      
   
  
  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ashtavinayak Cab Service",
  "image": "https://vedanttravels.in/assets/images/mumbai-to-ashtavinayak-cab-service.jpg",
  "description": "Book Mumbai to Ashtavinayak cab service with Vedant Travels for a safe, comfortable, and timely pilgrimage journey. AC sedans, SUVs, and tempo travellers available for one-way and round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-to-ashtavinayak-cab-service"
  }
};


  
      


    return (
        <div>
           
           <Helmet>
  <title>Mumbai to Ashtavinayak Cab Service | Comfortable Pilgrimage Ride | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai to Ashtavinayak cab service with Vedant Travels for a safe, comfortable, and timely pilgrimage journey. AC sedans, SUVs, and tempo travellers available for one-way and round trips." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Ashtavinayak Cab Service, Ashtavinayak Pilgrimage Cab, Mumbai to Ashtavinayak Taxi, Vedant Travels Mumbai Ashtavinayak, Pilgrimage Cab Booking Mumbai, Mumbai to Ashtavinayak Outstation Cab, Comfortable Cab Mumbai, AC Cab Mumbai to Ashtavinayak, One Way Cab Mumbai Ashtavinayak" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/76.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoashtavinayakcabservice;